(() => {
  const page = document.querySelector("[data-dad-bundle-page]");
  if (!page) return;

  const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const lightbox = page.querySelector("[data-image-lightbox]");
  const lightboxImg = page.querySelector("[data-image-lightbox-img]");
  const lightboxClose = lightbox ? lightbox.querySelector(".image-lightbox-close") : null;
  let lastZoomTrigger = null;

  const closeLightbox = () => {
    if (!lightbox || !lightboxImg) return;
    lightbox.hidden = true;
    lightboxImg.removeAttribute("src");
    lightboxImg.alt = "";
    document.documentElement.classList.remove("dad-image-lightbox-open");
    if (lastZoomTrigger) lastZoomTrigger.focus();
  };

  page.querySelectorAll("[data-zoom-image]").forEach((button) => {
    button.addEventListener("click", () => {
      if (!lightbox || !lightboxImg) return;
      lastZoomTrigger = button;
      lightboxImg.src = button.dataset.zoomImage;
      lightboxImg.alt = button.dataset.zoomAlt || "";
      lightbox.hidden = false;
      document.documentElement.classList.add("dad-image-lightbox-open");
      if (lightboxClose) lightboxClose.focus();
    });
  });

  if (lightbox) {
    lightbox.addEventListener("click", (event) => {
      if (event.target === lightbox) closeLightbox();
    });
  }

  if (lightboxClose) {
    lightboxClose.addEventListener("click", closeLightbox);
  }

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && lightbox && !lightbox.hidden) closeLightbox();
  });

  if (!prefersReducedMotion && "IntersectionObserver" in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.14, rootMargin: "0px 0px -60px 0px" });

    page.querySelectorAll("[data-reveal]").forEach((el) => observer.observe(el));
  } else {
    page.querySelectorAll("[data-reveal]").forEach((el) => el.classList.add("is-visible"));
  }

  page.querySelectorAll("[data-faq-button]").forEach((button) => {
    button.addEventListener("click", () => {
      const item = button.closest("[data-faq-item]");
      const panel = item ? item.querySelector("[data-faq-panel]") : null;
      const isOpen = button.getAttribute("aria-expanded") === "true";
      if (!item || !panel) return;

      page.querySelectorAll("[data-faq-item].is-open").forEach((openItem) => {
        if (openItem === item) return;
        const openButton = openItem.querySelector("[data-faq-button]");
        const openPanel = openItem.querySelector("[data-faq-panel]");
        openItem.classList.remove("is-open");
        if (openButton) openButton.setAttribute("aria-expanded", "false");
        if (openPanel) openPanel.style.maxHeight = null;
      });

      item.classList.toggle("is-open", !isOpen);
      button.setAttribute("aria-expanded", String(!isOpen));
      panel.style.maxHeight = isOpen ? null : `${panel.scrollHeight}px`;
    });
  });

  const sticky = page.querySelector("[data-sticky-cta]");
  const offer = page.querySelector("#offer");
  const hero = page.querySelector(".hero");
  if (sticky && "IntersectionObserver" in window) {
    let heroVisible = Boolean(hero);
    let offerVisible = false;
    const updateSticky = () => {
      sticky.classList.toggle("is-hidden", heroVisible || offerVisible);
    };

    if (hero) {
      const heroObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          heroVisible = entry.isIntersecting;
          updateSticky();
        });
      }, { threshold: 0.08 });
      heroObserver.observe(hero);
    }

    if (offer) {
      const offerObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          offerVisible = entry.isIntersecting;
          updateSticky();
        });
      }, { threshold: 0.12 });
      offerObserver.observe(offer);
    }

    updateSticky();
  } else if (sticky) {
    sticky.classList.remove("is-hidden");
  }
})();
